<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="mb-5">
          <v-card-text>
            <v-list>
              <v-subheader class="f2em">
                Bot
              </v-subheader>
              <v-list-tile v-for="(homologation, i) in botStatus" :key="`${i}-bot`" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs2 class="f1-2em">
                    {{statusName[homologation.status_id]}}
                  </v-flex>
                  <v-flex xs2 class="pr-3" v-if="$auth.user().permissions.includes('edit_rates')">
                    <v-text-field
                      v-model="homologation.rate"
                      label="Tarifa"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.action_code"
                      label="Acción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.result_code"
                      label="Resultado"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="pr-3">
                    <v-text-field
                      v-model="homologation.description"
                      label="Descripción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-list-tile v-if="botStatus.length === 0" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs12>
                    No se encontrarón estados
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-subheader class="f2em">
                Email
              </v-subheader>
              <v-list-tile v-for="(homologation, i) in emailStatus" :key="`${i}-email`" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs2 class="f1-2em">
                    {{statusName[homologation.status_id]}}
                  </v-flex>
                  <v-flex xs2 class="pr-3" v-if="$auth.user().permissions.includes('edit_rates')">
                    <v-text-field
                      v-model="homologation.rate"
                      label="Tarifa"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.action_code"
                      label="Acción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.result_code"
                      label="Resultado"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="pr-3">
                    <v-text-field
                      v-model="homologation.description"
                      label="Descripción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-list-tile v-if="emailStatus.length === 0" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs12>
                    No se encontrarón estados
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-subheader class="f2em">
                Sms
              </v-subheader>
              <v-list-tile v-for="(homologation, i) in smsStatus" :key="`${i}-sms`" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs2 class="f1-2em">
                    {{statusName[homologation.status_id]}}
                  </v-flex>
                  <v-flex xs2 class="pr-3" v-if="$auth.user().permissions.includes('edit_rates')">
                    <v-text-field
                      v-model="homologation.rate"
                      label="Tarifa"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.action_code"
                      label="Acción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.result_code"
                      label="Resultado"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="pr-3">
                    <v-text-field
                      v-model="homologation.description"
                      label="Descripción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-list-tile v-if="smsStatus.length === 0" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs12>
                    No se encontrarón estados
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-subheader class="f2em">
                Ivr
              </v-subheader>
              <v-list-tile v-for="(homologation, i) in ivrStatus" :key="`${i}-ivr`" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs2 class="f1-2em">
                    {{statusName[homologation.status_id]}}
                  </v-flex>
                  <v-flex xs2 class="pr-3" v-if="$auth.user().permissions.includes('edit_rates')">
                    <v-text-field
                      v-model="homologation.rate"
                      label="Tarifa"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.action_code"
                      label="Acción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.result_code"
                      label="Resultado"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="pr-3">
                    <v-text-field
                      v-model="homologation.description"
                      label="Descripción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-list-tile v-if="smsStatus.length === 0" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs12>
                    No se encontrarón estados
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-subheader class="f2em">
                Call - Discador
              </v-subheader>
              <v-list-tile v-for="(homologation, i) in humanStatus" :key="`${i}-human`" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs2 class="f1-2em">
                    {{statusName[homologation.status_id]}}
                  </v-flex>
                  <v-flex xs2 class="pr-3" v-if="$auth.user().permissions.includes('edit_rates')">
                    <v-text-field
                      v-model="homologation.rate"
                      label="Tarifa"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.action_code"
                      label="Acción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.result_code"
                      label="Resultado"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="pr-3">
                    <v-text-field
                      v-model="homologation.description"
                      label="Descripción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-list-tile v-if="humanStatus.length === 0" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs12>
                    No se encontrarón estados
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-subheader class="f2em">
                Call - Individual
              </v-subheader>
              <v-list-tile v-for="(homologation, i) in manualHumanStatus" :key="`${i}-manual_human`" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs2 class="f1-2em">
                    {{statusName[homologation.status_id]}}
                  </v-flex>
                  <v-flex xs2 class="pr-3" v-if="$auth.user().permissions.includes('edit_rates')">
                    <v-text-field
                      v-model="homologation.rate"
                      label="Tarifa"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.action_code"
                      label="Acción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.result_code"
                      label="Resultado"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="pr-3">
                    <v-text-field
                      v-model="homologation.description"
                      label="Descripción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-list-tile v-if="manualHumanStatus.length === 0" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs12>
                    No se encontrarón estados
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-subheader class="f2em">
               Visita
              </v-subheader>
              <v-list-tile v-for="(homologation, i) in visitStatus" :key="`${i}-visit`" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs2 class="f1-2em">
                    {{statusName[homologation.status_id]}}
                  </v-flex>
                  <v-flex xs2 class="pr-3" v-if="$auth.user().permissions.includes('edit_rates')">
                    <v-text-field
                      v-model="homologation.rate"
                      label="Tarifa"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.action_code"
                      label="Acción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.result_code"
                      label="Resultado"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="pr-3">
                    <v-text-field
                      v-model="homologation.description"
                      label="Descripción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-list-tile v-if="visitStatus.length === 0" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs12>
                    No se encontrarón estados
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-subheader class="f2em">
               Chat Center - Email
              </v-subheader>
              <v-list-tile v-for="(homologation, i) in inEmail" :key="`${i}-cemail`" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs2 class="f1-2em">
                    {{statusName[homologation.status_id]}}
                  </v-flex>
                  <v-flex xs2 class="pr-3" v-if="$auth.user().permissions.includes('edit_rates')">
                    <v-text-field
                      v-model="homologation.rate"
                      label="Tarifa"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.action_code"
                      label="Acción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.result_code"
                      label="Resultado"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="pr-3">
                    <v-text-field
                      v-model="homologation.description"
                      label="Descripción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-list-tile v-if="inEmail.length === 0" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs12>
                    No se encontrarón estados
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-subheader class="f2em">
               Chat Center - Sms
              </v-subheader>
              <v-list-tile v-for="(homologation, i) in inSms" :key="`${i}-csms`" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs2 class="f1-2em">
                    {{statusName[homologation.status_id]}}
                  </v-flex>
                  <v-flex xs2 class="pr-3" v-if="$auth.user().permissions.includes('edit_rates')">
                    <v-text-field
                      v-model="homologation.rate"
                      label="Tarifa"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.action_code"
                      label="Acción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.result_code"
                      label="Resultado"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="pr-3">
                    <v-text-field
                      v-model="homologation.description"
                      label="Descripción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-list-tile v-if="inSms.length === 0" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs12>
                    No se encontrarón estados
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-subheader class="f2em">
               Chat Center - Whatsapp
              </v-subheader>
              <v-list-tile v-for="(homologation, i) in inWhatsapp" :key="`${i}-ws`" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs2 class="f1-2em">
                    {{statusName[homologation.status_id]}}
                  </v-flex>
                  <v-flex xs2 class="pr-3" v-if="$auth.user().permissions.includes('edit_rates')">
                    <v-text-field
                      v-model="homologation.rate"
                      label="Tarifa"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.action_code"
                      label="Acción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 class="pr-3">
                    <v-text-field
                      v-model="homologation.result_code"
                      label="Resultado"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="pr-3">
                    <v-text-field
                      v-model="homologation.description"
                      label="Descripción"
                      color="grey"
                      class="a-border"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-list-tile v-if="inWhatsapp.length === 0" class="ml-3 my-4">
                <v-layout justify-center align-center>
                  <v-flex xs12>
                    No se encontrarón estados
                  </v-flex>
                </v-layout>
              </v-list-tile>
            </v-list>
          </v-card-text>
          <v-card-actions v-if="checkCreate()" class="pb-4 pr-5">
            <v-layout row wrap>
              <v-flex xs12 text-xs-right>
                <v-btn class="k-orange-linear" large @click="updateCompanyStatus">Guardar</v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import channels from '@/mixins/channels';
import status from '@/mixins/status';
import permissionsMixin from '@/mixins/permissions';

export default {
  mixins: [
    channels,
    status,
    permissionsMixin,
  ],
  created() {
    this.getCompanyStatus();
  },
  data() {
    return {
      homologations: [],
    };
  },
  methods: {
    getCompanyStatus() {
      this.axios.get('company_status').then((response) => {
        this.homologations = response.data;
        this.settingDescriptions();
      });
    },
    settingDescriptions() {
      this.homologations.forEach((item) => { // eslint-disable-next-line
        item.description = item.description != null ? item.description : `${this.showNameChannel(item.channel_id, true)} - ${this.statusName[item.status_id]}`;
      });
    },
    updateCompanyStatus() {
      this.axios.patch('company_status', {
        // eslint-disable-next-line
        company_status: this.botStatus.concat(this.emailStatus, this.smsStatus, this.ivrStatus, this.humanStatus, this.manualHumanStatus, this.visitStatus,
          this.inEmail, this.inSms, this.inWhatsapp),
      }).then(() => {
      });
    },
    checkCreate(){
      return this.checkPermissions([
        'edit_company_status',
      ]);
    },
  },
  computed: {
    botStatus() {
      return this.homologations.filter(item => item.channel_id === 4);
    },
    emailStatus() {
      return this.homologations.filter(item => item.channel_id === 1);
    },
    smsStatus() {
      return this.homologations.filter(item => item.channel_id === 2);
    },
    ivrStatus() {
      return this.homologations.filter(item => item.channel_id === 3);
    },
    humanStatus() {
      return this.homologations.filter(item => item.channel_id === 5);
    },
    manualHumanStatus() {
      return this.homologations.filter(item => item.channel_id === 6);
    },
    visitStatus() {
      return this.homologations.filter(item => item.channel_id === 10);
    },
    inEmail() {
      return this.homologations.filter(item => item.channel_id === 8);
    },
    inSms() {
      return this.homologations.filter(item => item.channel_id === 9);
    },
    inWhatsapp() {
      return this.homologations.filter(item => item.channel_id === 7);
    },
  },
};
</script>

<style scoped>
.a-border >>> .input-group__input {
  border:1px solid lightgray !important;
  padding-right:40px !important;
}

.a-border:not(.input-group--focused) >>> label {
  padding-right:20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/homologation/Index.vue